import React from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { Text } from "@bookingcom/bui-react";
import { BaggageItem } from "./BaggageItem.js";
import styles from "./BaggageSegment.module.css";
export const BaggageSegment = ({ flightSegment, baggageSegment, showHeader, hideIncludedSection }) => {
    return (React.createElement("div", null,
        showHeader && React.createElement(Header, { flightSegment: flightSegment }),
        React.createElement(BaggageSegmentList, { hideIncludedSection: hideIncludedSection, baggageSegment: baggageSegment })));
};
const Header = ({ flightSegment }) => {
    const i18n = useI18n();
    const { arrivalAirport } = flightSegment;
    return (React.createElement(Text, { variant: "strong_1", className: styles.header }, i18n.trans(t("flights_details_route", {
        variables: {
            city_name: arrivalAirport.cityName || arrivalAirport.name
        }
    }))));
};
const BaggageSegmentList = ({ baggageSegment, hideIncludedSection }) => {
    return (React.createElement(React.Fragment, null, baggageSegment.map((item, i) => {
        return (React.createElement("div", { className: styles.listItem, key: `${item.luggageType}-${i}` },
            React.createElement(BaggageItem, { luggage: item, hideIncludedSection: hideIncludedSection })));
    })));
};
